import ModalReceiptDetail from "./ModalReceiptDetail";

export default ModalReceiptDetail;
